import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CountryPickerService {

  constructor(private http : HttpClient) { }

  /**
   * Return a list of Countries from file based in assets/countries.json
   */
  getCountries() : Observable<any> {
    return this.http.get("assets/countries.json");
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/country-picker.service.ts